var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.92 14.276C40.753 24.974 25.715 39.591 22 41.836 18.285 39.591 3.246 24.973 2.079 14.261c0 0-.079-.576-.079-1.261C2 6.935 6.935 2 13 2c2.848 0 5.551 1.091 7.614 3.075L22 6l2.585-1.912A10.91 10.91 0 0 1 31 2c6.066 0 11 4.935 11 11 0 .698-.08 1.276-.08 1.276M44 13c0-7.18-5.82-13-13-13a12.947 12.947 0 0 0-9 3.632A12.947 12.947 0 0 0 13 0C5.82 0 0 5.82 0 13c0 .836.132 1.834.092 1.493C1.492 27.334 20.075 44 22 44c1.925 0 20.508-16.666 21.908-29.507-.039.341.092-.657.092-1.493",
    fill: "#3285C2",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassionIcon);
export default __webpack_public_path__ + "static/media/passion-icon.232b351b.svg";
export { ForwardRef as ReactComponent };